import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import useTitle from '../../../hooks/useTitle';
import PageHeader from '../../PageHeader';

function CycleCreateHeader({ header, modelSelector }) {
    const title = useSelector(state => header.title(modelSelector(state)));
    useTitle(title);

    return <PageHeader title={title} documentation={header.documentation} />;
}

CycleCreateHeader.propTypes = {
    header: PropTypes.shape({
        title: PropTypes.func.isRequired,
        documentation: PropTypes.object,
    }).isRequired,
    modelSelector: PropTypes.func.isRequired,
};

export default CycleCreateHeader;
